<div class="carousel">
    <div class="carousel-main"  [ngClass]="{'ignored-list': activateAction}">
        <div class="carousel-list">
            <ul>
                <li *ngFor="let item of pages" [ngClass]="{'hidden': hiddenPages.includes(item.page)}">
                    <a href="javascript:void(0)" class="with-actions" (click)="click(item)" [ngClass]="{'selected': selectedPage == item.page, 'ignored': deactivatePages.includes(item.page)}">
                        <span class="rotate-action" *ngIf="rotateAction"><button title="Rotate Image"><em>Rotate Image</em></button></span>
                        <core-preview-page-blur [format]="'small-height'" [fileId]="item.fileId" [page]="item.page" [property]="item.property"></core-preview-page-blur>
                    </a>
                    <div *ngIf="activateAction">
                        <button title="Ignore Image" class="ignore-action" (click)="activePage(item.page, false)" *ngIf="!deactivatePages.includes(item.page)"><em>Deactive Image</em></button>
                        <button title="Keep Image" class="keep-action" (click)="activePage(item.page, true)" *ngIf="deactivatePages.includes(item.page)"><em>Active Image</em></button>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</div>
